/*
 * Handlebars Compile Templates
 *
 * Authors:
 *  Rohit Gautam
 *
 */
var ezjHtmlTemplates = {
    getTemplates: function (key) {
        var content = $.ezdia.config.oldTemplates || {};
        var id = this.templateSource[key];
        if (!content[key]){
            content[key] = this._compile(id);
        }
        return content[key];
    },
    _compile: function (id) {
        var source = $(id).html();
        var compile = Handlebars.compile(source);
        return compile;
    },
    templateSource: {
        dashboardTabChart: '#createADivTemplate',
        dashboardSingleChart: '#createADivForSingleChartTemplate',
        dashboardRssFeed: '#rssFeedTemplate',
        dashboardTabChartPil: '#tabPilTemplate',
        dashboardTabChartPane: '#tabpaneTemplate',
        dashboardShareItems: '#dashboardShareItems',
        dashboardChartSearch: '#dashboardChartSearchTemplate',
        editorWarning: '#timymceWarningTemplate',
        editorWarningMsg: '#timymceWarningMsgTemplate',
        editorComment: '#edCommentTemplate',
        editorCommentLst: '#edCommentLstTemplate',
        editorCommentEdit: '#edCommentEditTemplate',
        localSaveWelcome: '#localSaveWelcomeTemplate',
        localSaveReview: '#localSaveReviewTemplate',
        grid: '#gridTemplate',
        gridColumnChooser: '#jgridColumnChooserTemplate',
        buildFieldOptions: '#buildFieldOptionsTemplate',
        deskActivityTimer: '#activityTimerTemplate',
        deskShareItems: '#shareItemsLink',
        deskWorkFlowHistory: '#workFlowHistoryTemplate',
        deskShowHistory: '#showHistoryTemplate',
        deskShowHistoryCompare: '#showHistoryCompareTemplate',
        fieldActionLink: '#fieldActionLinkTemplate',
        panelWrapperWithTabs: '#panelWrapperWithTabsTemplate',
        column: '#columnTemplate',
        heading: '#headingTemplate',
        listOk: '#listOkTemplate',
        labelParagraph: '#labelParagraphTemplate',
        personal: '#personalTemplate',
        openProjQA: '#openProjQATemplate',
        formFieldsEdit: '#formFieldsEditTemplate',
        popoverList: '#popoverListTemplate',
        formFieldsEditComposite: '#formFieldsEditCompositeTemplate',
        formAddFieldsEdit: '#formAddFieldsEditTemplate',
        creativeBrief: '#creativeBriefTemplate',
        inputList: '#inputListTemplate',
        jgridColumnExport: '#jgridColumnExportTemplate'
    }
};